export enum PaymentableTypeEnum {
    POINTING = 'pointing',
    BOOK_MEAL = 'bookMeal',
    ACTIVITY = 'activity',
    HOMEWORK = 'homework',
    CHARGE = 'charge',
    DECHARGE = 'decharge',
}
